import React from 'react'
import { useTranslation } from 'next-i18next'
import { ConsumerPage } from '../../model'

import { Head } from '../../component'
import { CreatePassword } from '../../component/CreatePassword/CreatePassword'
import { TrackPageViewed } from '../../integrations/amplitude'

export const CreatePasswordPage: ConsumerPage = () => {
  const { t } = useTranslation()

  const pageTitle = `${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <CreatePassword />
      <TrackPageViewed />
    </>
  )
}
